import { cx } from '@onbeam/business-styled-system/css';
import { flex } from '@onbeam/business-styled-system/patterns';
import { ArrowDiagonalIcon } from '@onbeam/icons/business';
import { PropsWithChildren } from 'react';

export const MenuItem = ({
  children,
  href,
  isExternal,
  className,
}: PropsWithChildren<{
  href?: string;
  className?: string;
  isExternal: boolean;
}>) => {
  const Component = href ? 'a' : 'div';

  return (
    <Component
      className={cx(
        flex({
          px: '4',
          py: '2.5',
          rounded: 'xs',
          transition: 'colors',
          cursor: 'pointer',
          textStyle: 'body-sm',
          justify: 'space-between',
          _hoverFocus: {
            bg: 'mono.quartenery',
          },
        }),
        className,
      )}
      {...(href && {
        href,
        ...(isExternal && { target: '_blank', rel: 'noopener noreferrer' }),
      })}
    >
      {children}
      {isExternal && <ArrowDiagonalIcon height={16} width={16} />}
    </Component>
  );
};
